import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage.jsx';
import Intake from './pages/Intake.jsx';
import Diagnosis from './pages/Diagnosis.jsx';
import CaseStudies from './pages/CaseStudies.jsx';
import CaseStudyDetail from './pages/CaseStudyDetail.jsx';
import WhoWeAre from './pages/WhoWeAre.jsx';
import './styles/tokens.css';
import './styles/global.css';
import './components/SlotPicker.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/intake" element={<Intake />} />
        <Route path="/diagnosis/:token" element={<Diagnosis />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="*" element={<Homepage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
